

















































































import { defineComponent, ref, Ref, computed } from '@vue/composition-api'

// componnents
import { PageHeader } from '@/components'
import { Select2 } from '@/components/form'
import { DatePicker } from '@/components/general'
import moment from 'moment'
// const
import { APP_URL_API, optionsSemestre2 } from '@/constants'

// utils
import { dateLibs, getFullNameFormat } from '@/utils'

// hooks
import { useHeadquarter, useArea, useEmployeesOp } from '@/hooks'

export default defineComponent({
  name: 'ReportAsistance',
  components: {
    PageHeader,
    DatePicker,
    Select2
  },
  setup () {
    const URL_PDF = 'reports/lbs'
    const title = ref('Reporte de LBS')
    const years = dateLibs.createRangeYears()
    const months = dateLibs.getAllMonths()
    const breadcrumbs = [
      {
        text: 'Dashboard',
        to: { name: 'home' }
      },
      {
        text: 'Reporte de LBS',
        active: true
      }
    ]
    const year = ref(null)
    const date_init = ref(null)
    const date_end = ref(null)
    const monthi = ref(null)
    const month = ref(null)
    const monthf = ref(null)
    const headquarter = ref(null)
    const area: Ref<number|null> = ref(null)
    const subArea: Ref<number|null> = ref(null)
    const employeesIds: Ref<number[]> = ref([])

    const { areasOptions, getAreasActive, loadingAreas, areas } = useArea()
    getAreasActive()

    const maxDateEnd = computed(() => {
      if (date_init.value) {
        console.log('holis')
        return moment(date_init.value).endOf('month').format('YYYY-MM-DD')
      }
      return null
    })

    const subareaOptions = computed(() => {
      const areaSelected = areas.value.find(a => Number(a.id) === Number(area.value))
      if (areaSelected) {
        return areaSelected.subAreas?.map(sub => {
          return {
            value: sub.id,
            text: sub.name
          }
        })
      }
      return []
    })

    const { employees, loadingEmployees } = useEmployeesOp()
    console.log(employees)
    const employeesOp = computed(() => {
      return employees.value.filter(employee => (employee.is_active === false))
      .map(employee => {
        return {
          value: employee.id,
          text: getFullNameFormat(employee)
        }
      })
    })

    const printReport = () => {
      window.open(`${APP_URL_API}${URL_PDF}?year=${year.value}&month=${month.value}&employees=${employeesIds.value}&tipo=1`, '_blank')
    }

    const printReport2 = () => {
      window.open(`${APP_URL_API}${URL_PDF}?year=${year.value}&month=${month.value}&employees=${employeesIds.value}&tipo=2`, '_blank')
    }

    const printReport3 = () => {
      window.open(`${APP_URL_API}${URL_PDF}?year=${year.value}&month=${month.value}&employees=${employeesIds.value}&tipo=3`, '_blank')
    }

    const addDaysToDate = (date: string) => {
      return dateLibs.addDaysToDate(date, 29)
    }

    const { headquartersSelectOptions, getHeadquatersActivated } = useHeadquarter()
    getHeadquatersActivated()

    return {
      title,
      breadcrumbs,
      years,
      months,
      year,
      monthi,
      monthf,
      month,
      date_init,
      date_end,
      moment,
      maxDateEnd,
      printReport,
      printReport2,
      printReport3,
      addDaysToDate,
      headquarter,
      headquartersSelectOptions,
      areasOptions,
      loadingAreas,
      area,
      subArea,
      employeesIds,
      optionsSemestre2,
      subareaOptions,
      employeesOp,
      loadingEmployees
    }
  }
})
